import { Injectable , Renderer2, RendererFactory2} from '@angular/core'
import { TranslocoService } from '@jsverse/transloco'
import { Subscription, take } from 'rxjs'

@Injectable({
   providedIn: 'root'
})
export class LanguageService {
   availableLanguages: string[]
   language = 'en'
   locSubscription: Subscription | null = null
   renderer2: Renderer2

   private mapping: Record<string, string> = {
      'afrikaans': 'af',
      'arabic': 'ar',
      'bengali': 'bn',
      'bulgarian': 'bg',
      'catalan': 'ca',
      'chinese': 'zh',
      'croatian': 'hr',
      'czech': 'cs',
      'danish': 'da',
      'dutch': 'nl',
      'estonian': 'et',
      'english': 'en',
      'finnish': 'fi',
      'french': 'fr',
      'german': 'de',
      'greek': 'el',
      'hebrew': 'he',
      'hindi': 'hi',
      'hungarian': 'hu',
      'icelandic': 'is',
      'indonesian': 'id',
      'irish': 'ga',
      'italian': 'it',
      'japanese': 'ja',
      'korean': 'ko',
      'latin': 'la',
      'latvian': 'lv',
      'lithuanian': 'lt',
      'luxembourgish': 'lb',
      'norwegian': 'no',
      'persian': 'fa',
      'polish': 'pl',
      'portuguese': 'pt',
      'romanian': 'ro',
      'russian': 'ru',
      'sanskrit': 'sa',
      'serbian': 'sr',
      'simplified chinese': 'zh-cn',
      'slovak': 'sk',
      'slovenian': 'sl',
      'spanish': 'es',
      'swedish': 'sv',
      'tamil': 'ta',
      'thai': 'th',
      'traditional chinese': 'zh-tw',
      'turkish': 'tr',
      'ukrainian': 'uk',
      'urdu': 'ur',
      'vietnamese': 'vi',
      'welsh': 'cy',
      'yiddish': 'yi'
   }

   constructor(rendererFactory: RendererFactory2, private translocoService: TranslocoService) {
      this.availableLanguages = this.translocoService.getAvailableLangs().map((lang) => lang.toString())
      this.renderer2 = rendererFactory.createRenderer(null, null)
   }

   getLanguageCode(language: string) {
      if (language) {
         language = language.toLowerCase()
      }
      return this.mapping[language]
   }

   changeLanguage(lang: string) {
      this.language = lang
      this.locSubscription?.unsubscribe()
      this.locSubscription =  this.translocoService
         .load(lang)
         .pipe(take(1))
         .subscribe(() => {
            const dir = ['he', 'ar', 'fa'].includes(lang) ? 'rtl' : 'ltr'

            this.renderer2.setAttribute(document.documentElement, 'dir', dir)

            const webComponent = document.querySelector('cdi-research-assistant')
            const rootEl = webComponent?.shadowRoot ?? document
            rootEl.querySelector('.component-container')?.setAttribute('dir', dir)

            this.translocoService.setActiveLang(lang)
         })
   }
}
